export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/ob-step-2.png?5189a2dd4842bb72e8b01ea4bd86b2ed";